/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useCallback } from 'react';
import Button from '@mui/material/Button';
import { useStateContext } from '../../../contexts/ContextProvider';
import { addQuestionnairesFn, getQuestionnairesFn } from '../../../api/api';
import SweetAlert from 'sweetalert2/src/sweetalert2.js';
import { FormGroup, Label, Container, Modal } from 'reactstrap';
import { useTranslation } from 'react-i18next';

function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}
function containsSuccess(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Success');
}

function AddQuestionnaires() {
  const { t } = useTranslation();
  const { basictoaster, primary, setQuestionnaires, setLoading, setExecuting } = useStateContext();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: 0,
    description: '',
    link: '',
  });
  const [errors, setErrors] = useState({});

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  }
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = useCallback(() => {
    const { description, link } = formData;
    const newErrors = {};

    if (!description) {
      newErrors.description = 'La descrizione è richiesta';
    }
    if (!link) {
      newErrors.link = 'Il link è richiesto';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [formData]);

  useEffect(() =>  {
    validateForm();
  }, [formData, validateForm])

  const addQuestionnaire = () => {
    SweetAlert.fire({
        title: 'Sei sicuro?',
        text: 'Questo questionario verrà aggiunto',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true
    })
        .then(async (result) => {
          if (result.value) {
            setExecuting(true);
            const qstObj = {
              id: formData.id,
              description: formData.description,
              link: formData.link,
            };
            // console.log(movObj)
            await addQuestionnairesFn(qstObj).then(async (response) => {
              setLoading(true);
              getQuestionnairesFn().then((resp) => {   
                setQuestionnaires(resp);
                setLoading(false);
              }).catch((err) => {basictoaster("error", "Errore questionari", err, () => {})})
              if (containsSuccess(response)) {
                  SweetAlert.fire(
                      'Fatto!',
                      'Il tuo questionario è stato aggiunto!',
                      'success'
                  );
              } else if (containsError(response)) {
                SweetAlert.fire(
                    'Errore!',
                    `${t('Errore')}: ${response.Error}.`,
                    'error'
                );
              }
              setExecuting(false);
            }).catch((err) => {basictoaster("error", 'Errore nell\'aggiunta del questionario', err, () => {})});
          }
        });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      addQuestionnaire();
    }
  };

  return (
    <>
      <Button variant="contained" style={{ backgroundColor: primary }} onClick={handleOpen}>Aggiungi questionario</Button>
      <Modal
        isOpen={open}
        toggle={handleClose}
        centered
        backdropClassName={open ? 'BDModalOpen' : 'BDModalClosed'}
        modalClassName={open ? 'ModalOpen' : 'ModalClosed'}
      >
        <Container fluid={true} style={{ padding: '20px' }}>
        <form style={{ margin: '10%', marginTop: '1%', marginBottom: '1%' }} onSubmit={handleSubmit} >
              {/* DESCRIPTION */}
              <FormGroup>
                <Label htmlFor="description" className="col-form-label pt-0">Descrizione <span className='form-required-symbol'>*</span></Label>
                <input
                  className="form-control"
                  type="text"
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                />
                {errors.description && <div style={{ color: 'red' }}>{errors.description}</div>}
              </FormGroup>
              {/* LINK */}
              <FormGroup>
                <Label htmlFor="link" className="col-form-label pt-0">Link <span className='form-required-symbol'>*</span></Label>
                <input
                  className="form-control"
                  type="text"
                  id="link"
                  name="link"
                  value={formData.link}
                  onChange={handleChange}
                />
                {errors.link && <div style={{ color: 'red' }}>{errors.link}</div>}
              </FormGroup>
              <Button
                variant="contained"
                type="submit"
                style={{ backgroundColor: primary }}
                className=""
              >
                Aggiungi
              </Button>
              <Button
                variant="contained"
                type="button"
                onClick={handleClose}
                style={{ backgroundColor: 'gray', marginLeft: '1%' }}
                className=""
              >
                Annulla
              </Button>
            </form>
        </Container>
      </Modal>
    </>
  );
}

export default AddQuestionnaires;
